import {
  Box,
  Button,
  Divider,
  Flex,
  Text,
} from '@chakra-ui/react';
import MuiIcon from 'components/MuiIcon';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useGetOneService, useGet3thPartyServices } from 'shared/api/requests/services';
import Card from 'shared/components/horizon-ui/card/Card';
import Link from 'shared/components/Link';
import Loader from 'shared/components/Loader';
import MainModelInfo from 'shared/components/MainModelInfo';
import useGetColors from 'shared/hooks/useGetColors';
import { PathsE, PathsParams } from 'shared/routes';
import ModelInfo from './ModelInfo';
import PageTitle from 'shared/views/admin/PageTitle';

const Show = () => {
  const { t } = useTranslation();
  const { settingId, serviceId } = useParams<PathsParams[PathsE.SHOW_SETTING]>();
  const {
    gray800,
    gray700,
    gray100,
  } = useGetColors();
  const requestParams = {
    pathParams: { settingId, serviceId },
    params: {},
  };

  const { data: currentService } = useGetOneService({
    pathParams: { serviceId },
    params: undefined
  });

  const { useGetOneSetting } = useGet3thPartyServices({
    domain: currentService?.domain,
    token: currentService?.token,
  });
  const { data, isPending } = useGetOneSetting(requestParams);

  const breadcrumbs = [
    {
      path: PathsE.HOME,
      text: t('general.home'),
    },
    {
      path: PathsE.SETTINGS,
      text: t('services.settings'),
      pathsParams: {
        serviceId,
      },
    },
  ];

  if (isPending || !data) return <Loader />;

  return (
    <Box>
      <PageTitle
        title={data.key}
        breadcrumbs={breadcrumbs}
        backUrl={{ path: PathsE.SETTINGS, pathsParams: { serviceId } }}
      />
      <Card mb="20px" borderRadius="20px" px="30px">
        <Flex justifyContent="space-between" alignItems="center" mt="-10px">
          <Text color={gray700} fontWeight="600">
            {data.key}
          </Text>
          <Flex alignItems="center">
            <Box mr="10px">
              <Link<PathsParams[PathsE.UPDATE_SETTING]>
                path={PathsE.UPDATE_SETTING}
                pathsParams={{ settingId, serviceId }}
              >
                <Button
                  color={gray800}
                  bgColor={gray100}
                  borderRadius="8px"
                  leftIcon={<MuiIcon name="edit" />}
                >
                  {t('services.editSetting')}
                </Button>
              </Link>
            </Box>
          </Flex>
        </Flex>
        <MainModelInfo data={data} />
        <ModelInfo data={data} />
        <Divider my="20px" />
      </Card>
    </Box>
  );
};

export default Show;
